import { ICurrency } from "@/entities";

export class Currency implements ICurrency {
  readonly id?: number;
  readonly code?: string;
  readonly symbol?: string;

  constructor(data: ICurrency) {
    this.id = data.id;
    this.code = data.code;
    this.symbol = data.symbol;
  }
}
